import React from 'react';
import { ArrowRightIcon, InstagramIcon, MapPinIcon } from 'lucide-react';
import { brand, images, nav } from '../data/site';
export function SiteFooter() {
  return <footer className="relative overflow-hidden bg-espresso text-cream" data-id="element-121" data-mp="3ralvblorh3th">
      <img src={images.counter} alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover opacity-15" data-id="element-122" data-mp="3mfq0yew1y4d7" />
      <div className="relative mx-auto max-w-6xl px-6 py-16 lg:py-20" data-id="element-123" data-mp="3dh4jyo68axej">
        <div className="flex flex-col gap-8 border-b border-cream/15 pb-12 lg:flex-row lg:items-end lg:justify-between" data-id="element-124" data-mp="38i1fb4u5ut73">
          <div data-id="element-125" data-mp="33hvk5eoomok9">
            <img src={brand.logo} alt={brand.name} className="h-9 w-auto brightness-0 invert" data-id="element-126" data-mp="33jgeb37345hl" />
            <p className="mt-6 max-w-lg text-[clamp(1.6rem,3.2vw,2.5rem)] font-semibold leading-[1.1] tracking-[-0.03em]" data-id="element-127" data-mp="2ykn87vu4ngrg">
              Word lid en verdien je eerste koffie vandaag nog.
            </p>
          </div>
          <a href="#app" className="group inline-flex w-fit items-center gap-2.5 rounded-full bg-cream px-8 py-4 text-sm font-medium text-ink transition-colors duration-150 ease-out hover:bg-clay hover:text-cream" data-id="element-128" data-mp="wsqohyxt30ll">
            Download de app
            <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-x-0.5" data-id="element-129" data-mp="vtqvrrtaa2bl" />
          </a>
        </div>

        <div className="grid gap-10 py-12 sm:grid-cols-2 lg:grid-cols-4" data-id="element-130" data-mp="10tlkppti0hu0">
          <nav aria-label="Voettekst" data-id="element-131" data-mp="1oi4uk9s752o7">
            <h2 className="text-sm text-cream/45" data-id="element-132" data-mp="1tg6esy1cz819">Menu</h2>
            <ul className="mt-4 space-y-3" data-id="element-133" data-mp="1tfo817h2lbf3">
              {nav.map(item => <li key={item.href} data-id="element-134" data-mp="1eqs3vli4wijr">
                  <a href={item.href} className="text-sm text-cream/85 transition-colors duration-150 ease-out hover:text-clay" data-id="element-135" data-mp="1eppbf955y81q">
                    {item.label}
                  </a>
                </li>)}
            </ul>
          </nav>

          <div data-id="element-136" data-mp="2m2xmtvi132a8">
            <h2 className="text-sm text-cream/45" data-id="element-137" data-mp="2m3fstjuhsuvc">Adres</h2>
            <address className="mt-4 not-italic text-sm leading-relaxed text-cream/85" data-id="element-138" data-mp="2m0tlnlbikhdn">
              {brand.address.map(line => <span key={line} className="block" data-id="element-139" data-mp="2d1q2yig9e3zo">
                  {line}
                </span>)}
            </address>
            <a href="https://maps.google.com/?q=Burgemeester+de+Vlugtlaan+198+Amsterdam" target="_blank" rel="noreferrer" className="mt-4 inline-flex items-center gap-2 text-sm text-cream/60 transition-colors duration-150 ease-out hover:text-clay" data-id="element-140" data-mp="282mxwy0a3xrp">
              <MapPinIcon className="h-4 w-4" aria-hidden="true" data-id="element-141" data-mp="1tc5wvfrk39vc" /> Route plannen
            </a>
          </div>

          <div data-id="element-142" data-mp="1pau5p5t1agl1">
            <h2 className="text-sm text-cream/45" data-id="element-143" data-mp="1kdaru70905tm">Openingstijden</h2>
            <p className="mt-4 text-sm leading-relaxed text-cream/85" data-id="element-144" data-mp="1kfn5i7yz3u0v">
              Maandag t/m zondag
              <span className="mt-1 block text-cream/60" data-id="element-145" data-mp="1fgk91bx26w4i">08:00 – 22:00</span>
            </p>
          </div>

          <div data-id="element-146" data-mp="3r46yp9dmuuvk">
            <h2 className="text-sm text-cream/45" data-id="element-147" data-mp="3w0nqqenydtdx">Volg ons</h2>
            <a href="https://www.instagram.com/adens.viennoiserie" target="_blank" rel="noreferrer" className="mt-4 inline-flex items-center gap-2 text-sm text-cream/85 transition-colors duration-150 ease-out hover:text-clay" data-id="element-148" data-mp="3vz2xcsddkghn">
              <InstagramIcon className="h-4 w-4" aria-hidden="true" data-id="element-149" data-mp="38d63mwfmvjha" /> Instagram
            </a>
            <p className="mt-6 text-sm leading-relaxed text-cream/55" data-id="element-150" data-mp="3dao561rbmwf9">
              Al onze producten zijn 100% halal bereid.
            </p>
          </div>
        </div>

        <div className="flex flex-col gap-3 border-t border-cream/15 pt-6 text-sm text-cream/45 sm:flex-row sm:items-center sm:justify-between" data-id="element-151" data-mp="3m3rnoogtpzgr">
          <span data-id="element-152" data-mp="2pj0v0via3zzo">{brand.tagline}</span>
          <span data-id="element-153" data-mp="2tlnh0fs9qqoy">© {new Date().getFullYear()} Aden’s Viennoiserie</span>
        </div>
      </div>
    </footer>;
}